import { Component, ChangeDetectionStrategy } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { COMMON_IMPORTS } from "../common-imports"
import { ConfigDefinitions } from "@app/definitions/types"
import { ApiService } from "@app/services/api.service"
import { ModalService } from "@app/services/modal.service"
import { PermsService } from "@app/services/perms.service"
import { StoreService } from "@app/services/store.service"
import { environment } from "@env/environment"
import * as moment from "moment"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { SpinOrContent } from "@app/utils/utils.component"
import { CalendarComponent } from "@app/calendar/calendar.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { GuestCalFormComponent } from "@app/guest-cal-form/guest-cal-form.component"

@Component({
	selector: "app-guest-calendar",
	imports: [
		COMMON_IMPORTS,
		LangValPipe,
		SpinOrContent,
		CalendarComponent,
		ModalWrapComponent,
		GuestCalFormComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div class="site-menu">
			<div
				class="cont"
				style="justify-content: end;"
			>
				<div
					title="My-cliniq"
					class="d-flex align-items-center gap-3"
				>
					<button
						class="btn btn-icon fixed-corner help-btn"
						(click)="reload()"
						titleLang="refresh"
						icon="recurring2"
						style="
							background: var(--light-grey) !important;
							padding: 10px 6px !important;
							border-radius: 0 50% 50% 0;
							bottom: 0;
							left: -6px;
							"
					></button>

					@if (store.deferredPrompt) {
						<button
							titleLang="install_app"
							class="login-text-button btn btn-primary"
							(click)="pwaInstall()"
						>
							{{ "install_app" | langVal }}
						</button>
					}
					<img
						src="assets/images/main-logo.svg"
						class="LOGO"
					/>
				</div>
			</div>
		</div>

		<app-spin-or-content [isSpin]="!showCalendar">
			@if (showCalendar) {
				<app-calendar
					isGuest
					(guestClick)="handleClick($event)"
				/>
			}
		</app-spin-or-content>
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null"
				modalWrapperClass="modal-wide"
				title="cal_reminder"
			>
				<app-guest-cal-form
					(onClose)="handleFormClose($event)"
					[inputDate]="modalProps.inputDate"
				/>
			</app-modal-wrap>
		}
	`,
})
export class GuestCalendarComponent {
	modalProps: any = null
	showCalendar: boolean = false
	fdsewrfsdfds: string = ""
	hgfe5ty6hjtgft454tr: string = ""
	environment = environment

	constructor(
		protected store: StoreService,
		public permsService: PermsService,
		public modalService: ModalService,
		private apiService: ApiService,
		protected route: ActivatedRoute
	) {
		this.route.queryParams.subscribe((params) => {
			Object.keys(params).forEach((key) => {
				this[key] = params[key]
			})
			if (this.fdsewrfsdfds && this.hgfe5ty6hjtgft454tr) {
				this.load()
			}
		})
	}
	reload() {
		location.reload()
	}
	async pwaInstall() {
		this.store.deferredPrompt.prompt()
		const { outcome } = await this.store.deferredPrompt.userChoice
		// Optionally, send analytics event with outcome of user choice
		console.log(`User response to the install prompt: ${outcome}`)
		// We've used the prompt, and can't use it again, throw it away
		this.store.deferredPrompt = null
	}
	keysObj() {
		return {
			fdsewrfsdfds: this.fdsewrfsdfds,
			hgfe5ty6hjtgft454tr: this.hgfe5ty6hjtgft454tr,
		}
	}

	async load() {
		const res: any = await this.apiService.post(
			"guest_get_cal_data",
			this.keysObj()
		)
		if (res) {
			this.store.ccForGuestCal = res.cc
			this.store.data.siteData = res.siteData
			this.permsService.load(res.perms, res.owner_has_users)
			this.store.getAllFusLoad(res.fuses, res?.meeting_requests)
			this.showCalendar = true
		}
	}
	async handleFormClose(obj: any = null) {
		const { patient_id, followupserie_id } = this.modalProps
		this.modalProps = null
		if (!obj) {
			return
		}
		await this.apiService.post("guest_cal_task", {
			...this.keysObj(),
			...obj,
			patient_id,
			followupserie_id,
		})
	}
	async handleClick({ date, patient_id = 0, followupserie_id = 0 }: any) {
		this.modalProps = {
			inputDate: date,
			patient_id,
			followupserie_id,
		}
	}
}
